import React from 'react';
import { Link } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import { fetchUserPacks } from '../../../api/packInventory';

const PacksCard = () => {
    const { data: packs, loading } = useFetch(fetchUserPacks, []);

    const withAmount = (packs || []).filter(p => p.amount > 0);
    if (loading || withAmount.length === 0) return null;

    const totalPacks = withAmount.reduce((sum, p) => sum + p.amount, 0);
    const packSummary = withAmount.map(p => `${p.amount}× ${p.Series?.name || `Series ${p.seriesID}`}`).join(' · ');

    return (
        <div className="priority-card accent-gold">
            <div className="action-row">
                <div>
                    <h3
                        style={{
                            fontFamily: "'New Amsterdam', sans-serif",
                            fontSize: '1.3rem',
                            letterSpacing: '1px',
                            color: '#212529',
                            margin: 0,
                        }}
                    >
                        {totalPacks} Unopened Pack{totalPacks !== 1 ? 's' : ''}
                    </h3>
                    <div className="action-detail">{packSummary}</div>
                </div>
                <Link to="/packs/user" className="card-cta gold">
                    Open Packs
                </Link>
            </div>
        </div>
    );
};

export default PacksCard;
